import { AppContext, CancelFromInceptionConst, CancelRider, CancelRiderFromInceptionService, CancelRiderFromInceptionSubmission, CancelRiderService, Checkbox, CheckboxTable, CheckboxTableColum, ErrorHandling, formatNumberWithComma, GeneralInfoService, GeneralService, HCR9BenefitInformationModal, HCR9BenefitInformationResponse, ImgUploadMutiple, Panel, PayoutPopup, ProductEnum, PulseOpsFormat, Select, SelectedRowProps, sharedStyle, SortFieldInfo, SubmissionService, TaskType, Title, TopUpService, TransactionType } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, SafeAreaView, Text, View, TouchableOpacity } from 'react-native'
import { Controller, FieldArrayWithId, useFieldArray, useForm, useWatch } from 'react-hook-form'
import { CancelRiderFormData } from '../cancel-rider'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import { useLoading } from '@mxt/zio-react'
import { useIsFocused } from '@react-navigation/native'
import { mapCashOutOption, PayoutMethod, PayoutMethodRef } from '../../payout-method'
import { FieldDescription, FieldText, SectionCol, SectionContent, SectionRow, Error } from '@pulseops/submission/common'
import { CancelRiderFromInceptionForm } from './cancel-rider-from-inception-form'
import { PolicyServiceProps, UploadedFilesInfo } from '../policy-service-props'
import { RequestAuthenticateData } from '../../request-authen'
import moment from 'moment'
import * as O from 'fp-ts/lib/Option'

type CancelRiderFromInceptionProps = PolicyServiceProps<CancelRiderFromInceptionSubmission.SubmitedData>
export const CancelRiderFromInception = (props: CancelRiderFromInceptionProps) => {
  const { t, i18n } = useTranslation()
  const [isLoading, bindLoader] = useLoading(false)
  const isFocused = useIsFocused()
  const { isConfirmed, policyNumber, officeCode, initSubmission } = props
  const { showToast, showGlobalLoading } = React.useContext(AppContext.AppContextInstance)
  const payoutRef = React.useRef<PayoutMethodRef | null>(null)
  const [payoutData, setPayoutData] = React.useState<PayoutPopup.Summary[]>([])
  const [hasFileNetAccess, setHasFileNetAccess] = React.useState<boolean>(false)
  const [requireFileAttachment, setRequireFileAttachment] = React.useState<boolean>(false)
  const [isRefundCardFlag, setIsRefundCardFlag] = React.useState<boolean>(false)
  const [allowedPayoutMethods, setAllowedPayoutMethods] = React.useState<PayoutPopup.PayoutMethods[]>([])
  const [hasClickRecalRefundAmount, setHasClickRecalRefundAmount] = React.useState<boolean>(false)
  const [sortItem, setSortItem] = React.useState<SortFieldInfo>({
    field: '',
    order: 'asc'
  })
  const [isOpenHCR9BenefitModal, setIsOpenOpenHCR9BenefitModal] = React.useState(false)
  const [HCR9BenefitInformation, setHCR9BenefitInformation] = React.useState<HCR9BenefitInformationResponse[]>([])

  const policyNum = pipe(
    policyNumber,
    O.fromNullable,
    O.fold(
      () => '',
      (itemData) => itemData
    )
  )
  const { control, reset, watch, setValue, trigger, getValues } = useForm<CancelRiderFromInceptionForm.CancelRiderFromInceptionData>({
    defaultValues: {
      cancelAllRider: false,
      LARiderForm: [],
      reEstimatedInstallPremium: 0,
      fileAttachment: [],
      // suspendAmount: '0',
      reason: undefined,
      riderRefundAmount: 0,
      tempRefundFee: 0
    }
  })
  const cancelRiderFormArray = useFieldArray({
    control: control,
    name: "LARiderForm"
  })

  const cancelRiderFormArrayVal = useWatch({
    control: control,
    name: "LARiderForm"
  })

  const riderRefundAmount = useWatch({
    control: control,
    name: "riderRefundAmount"
  })

  const displayedBenefitColumns: CheckboxTableColum[] = [
    {
      title: t('PRUFlexiHealthBenefit:Benefit'),
      fieldName: 'benefitName',
      disabled: true,
      rowRender: (selectedRow) => {
        const benefitName = selectedRow.selectItem["benefitName"] as string
        const benefitCode = selectedRow.selectItem["benefitCode"] as string
        const customedName = i18n.language === 'en' ? benefitCode : benefitName
        return <Text>{customedName}</Text>
      }
    },
    {
      title: t('claim:SumAssured'),
      fieldName: 'sumInsurance',
      disabled: true,
      rowRender: (selectedRow) => {
        const sumInsurance = selectedRow.selectItem["sumInsurance"] as number
        return <Text>{PulseOpsFormat.thousandSepartor(sumInsurance)}</Text>
      }
    },
    {
      title: t('PRUFlexiHealthBenefit:Copay'),
      fieldName: 'coPay',
      disabled: true
    },
    {
      title: t('requestInfo:InstallmentPremium'),
      fieldName: 'installPremium',
      disabled: true,
      rowRender: (selectedRow) => {
        const installPremium = selectedRow.selectItem["installPremium"] as number
        return <Text>{PulseOpsFormat.thousandSepartor(installPremium)}</Text>
      }
    },

  ]

  React.useEffect(() => { showGlobalLoading(isLoading) }, [isLoading])

  React.useEffect(() => {
    if (isFocused && policyNum) {
      pipe(
        ZIO.zipPar(
          CancelRiderService.getClientRiderInfo(policyNum),
          TopUpService.GetPolicyExtraInfo([policyNum], ''),
          CancelRiderService.getRiderInfoList(),
          SubmissionService.getFileNetAccess(policyNum),
          CancelRiderFromInceptionService.getCustomerReceivedDateOfRider(policyNum),
          CancelRiderFromInceptionService.getEffectiveDateDropRiderOfProduct(policyNum)
        ),
        ZIO.map(([riderClientArr, policyExtraInfo, riderNameList, fileNetAccess, receivedDatesOfRider, effectiveDateDropRider]) => {
          let LARiderFormArray: Array<CancelRiderFormData.RiderForm> = []
          let enabledRider = false
          // setValue("suspendAmount", customedSuspendAmount)
          setHasFileNetAccess(fileNetAccess)
          if (fileNetAccess) {
            setIsRefundCardFlag(true)
            setAllowedPayoutMethods([
              PayoutPopup.PayoutMethods.PAYPREMIUM,
              PayoutPopup.PayoutMethods.PAYLOAN,
              PayoutPopup.PayoutMethods.OTHER
            ])
          } else {
            setAllowedPayoutMethods([
              PayoutPopup.PayoutMethods.PAYPREMIUM,
              PayoutPopup.PayoutMethods.PAYLOAN,
              PayoutPopup.PayoutMethods.OTHER,
              PayoutPopup.PayoutMethods.CASHLESS,
              PayoutPopup.PayoutMethods.PAID_AT_BANK,
              PayoutPopup.PayoutMethods.BANKTRANSFER,
            ])
          }
          const riskCommenceDateOfPolicy = pipe(
            O.fromNullable(policyExtraInfo.policyExtraInfoDetail.find((x) => x.lifeNo === '01' && x.coverageNo === '01' && x.riderNo === '00')),
            O.fold(
              () => '',
              (item) => item.riskCommDate
            )
          )
          const LAListWithRider = riderClientArr.map((clientItem) => {
            // filter x.lifeNo !=="01", x.coverageNo !=="01", x.riderNo !=="00" to get only rider products
            const cancelRiderList = policyExtraInfo.policyExtraInfoDetail
              .filter(
                (x) =>
                  (x.lifeNo !== '01' || x.coverageNo !== '01' || x.riderNo !== '00') &&
                  x.lifeNo === clientItem.life &&
                  x.riderStatus === ProductEnum.Status.IF &&
                  !CancelRider.UnCancelRiderList.includes(x.productCode)
              )
              .map((extraItem) => ({
                productCode: String(extraItem?.productCode),
                productName: '',
                riskCessDate: String(extraItem?.riskCessDate),
                riskCommDate: String(extraItem?.riskCommDate),
                lapsedDate: '',
                sumAssured: Number(extraItem?.sumAssured),
                installmentPrem: Number(extraItem?.installmentPremium),
                newInstallmentPremium: 0,
                lifeNo: extraItem.lifeNo,
                coverageNo: extraItem.coverageNo,
                riderNo: extraItem.riderNo,
                riderStatus: extraItem.riderStatus
              }))
            return {
              clientName: clientItem.clientName,
              lifeAssured: clientItem.clientNumberOfLA,
              riders: cancelRiderList
            }
          })

          LAListWithRider.map((LAItem) => {
            LAItem.riders.map((rider) => {
              const riderInfoItem = riderNameList.find((x) => x.code === rider.productCode)
              rider.productName = getRiderName(riderInfoItem, i18n.language)
              const isFirstLA = rider.lifeNo === '01'
              enabledRider = false
              const { TF57TransactionDateOfRider, customerReceivedDateOfRider } = pipe(
                O.fromNullable(isFirstLA
                  ? receivedDatesOfRider.find((p) => p.coverageCode === rider.productCode && p.lifeNo === rider.lifeNo && p.riderNo === rider.riderNo)
                  : receivedDatesOfRider.find((p) => p.coverageCode === rider.productCode && p.lifeNo === rider.lifeNo && p.coverageNo === rider.coverageNo)
                ),
                O.fold(
                  () => ({
                    TF57TransactionDateOfRider: '',
                    customerReceivedDateOfRider: ''
                  }),
                  (receivedDate) => {
                    return {
                      TF57TransactionDateOfRider: receivedDate.tf57TransactionDate,
                      customerReceivedDateOfRider: receivedDate.customerReceivedDate
                    }
                  }
                )
              )
              if (moment(rider.riskCommDate).valueOf() !== moment(riskCommenceDateOfPolicy).valueOf()
                && moment(TF57TransactionDateOfRider).isSameOrAfter(moment(effectiveDateDropRider))
                && (moment(new Date()).diff(customerReceivedDateOfRider, 'days') <= 21 || customerReceivedDateOfRider === '')
              ) {
                enabledRider = true
              } else {
                enabledRider = false
              }
              LARiderFormArray.push({
                riderCode: rider.productCode,
                riderName: rider.productName,
                SelectRowForRider: false,
                riskCommDate: rider.riskCommDate,
                riskCessDate: rider.riskCessDate,
                sumAssured: rider.sumAssured,
                installmentPrem: rider.installmentPrem,
                newInstallmentPremium: 0,
                lifeNo: rider.lifeNo,
                coverageNo: rider.coverageNo,
                riderNo: rider.riderNo,
                riderStatus: rider.riderStatus,
                disabledRider: !enabledRider
              })
            })

            cancelRiderFormArray.append({
              selectAllForLA: false,
              LAName: LAItem.clientName,
              lifeAssured: LAItem.lifeAssured,
              cancelRiderForm: LARiderFormArray
            })
            LARiderFormArray = []
          })
        }),
        bindLoader,
        ErrorHandling.run()
      )
    }
    return () => {
      cancelRiderFormArray.remove()
      setRequireFileAttachment(false)
      setHasFileNetAccess(false)
      setIsRefundCardFlag(false)
      setHasClickRecalRefundAmount(false)
      payoutRef.current?.clearData()
      setAllowedPayoutMethods([])
      reset({
        cancelAllRider: false,
        LARiderForm: [],
        reEstimatedInstallPremium: 0,
        fileAttachment: [],
        // suspendAmount: '0',
        reason: undefined,
        riderRefundAmount: 0,
        tempRefundFee: 0
      })
    }
  }, [isFocused])

  const getRiderName = (item: any, isEN = 'en') => {
    return !!item ? (isEN === 'en' ? item.name : item.nameVi) : ''
  }

  const isDisabledRecalRefundButton = React.useMemo(() => {
    const isSelectedRider = cancelRiderFormArrayVal.some((lifeAssuredItem) => lifeAssuredItem.cancelRiderForm.some((riderItem) => riderItem.SelectRowForRider))
    !isSelectedRider && setValue('riderRefundAmount', 0)
    return !isSelectedRider
  }, [cancelRiderFormArrayVal])

  const totalPayoutAmount = React.useMemo(() => {
    return payoutData.reduce((total, item) => item.amount + total, 0)
  }, [payoutData])

  const netAmountAvailable = React.useMemo(() => {
    return riderRefundAmount + watch("tempRefundFee")
  }, [riderRefundAmount])

  const convertStringToDateString = (strDate: string) => {
    return moment(strDate).format('DD/MM/YYYY')
  }

  const convertNumberToCurrencyFormat = (value: number) => {
    return formatNumberWithComma(value)
  }

  const getRiderDisplayedColumns = (index: number, fieldItem: FieldArrayWithId<CancelRiderFromInceptionForm.CancelRiderFromInceptionData, "LARiderForm", "id">) => {
    return [
      {
        title: '',
        fieldName: '',
        disabled: true,
        headerColumnRender: (_: any) => {
          return (
            <Controller
              control={control}
              name={`LARiderForm.${index}.selectAllForLA`}
              render={({ field: { onChange, onBlur, value } }) => (
                <Checkbox
                  onChange={(checked) => {
                    onChange(checked)
                    onAllRiderSelectedEventForLA(checked, index, fieldItem)
                  }}
                  onBlur={onBlur}
                  value={value}
                  disabled={props.isConfirmed}
                  checkBoxStyle={cancelRiderStyles.tableCheckBox}
                />
              )}
            />
          )
        },
        rowRender: (selectedRow: SelectedRowProps) => {
          const subIndex = selectedRow.index
          // const riderInfo = fieldItem.cancelRiderForm[subIndex]
          return (
            <Controller
              control={control}
              name={`LARiderForm.${index}.cancelRiderForm.${subIndex}.SelectRowForRider`}
              render={({ field: { onChange, onBlur, value } }) => (
                <Checkbox
                  onChange={(val) => {
                    onChange(val)
                    setHasClickRecalRefundAmount(false)
                  }}
                  onBlur={onBlur}
                  value={value}
                  disabled={props.isConfirmed || fieldItem.cancelRiderForm[subIndex].disabledRider}
                  checkBoxStyle={cancelRiderStyles.tableCheckBox}
                />
              )}
            />
          )
        }
      },
      {
        title: t('requestInfo:RiderName'),
        fieldName: 'riderName',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riderCode = selectedRow.selectItem["riderCode"] as string
          const riderName = selectedRow.selectItem["riderName"] as string
          const lifeNo = selectedRow.selectItem["lifeNo"] as string
          const isHCR9Product = riderCode === 'HCR9'
          return isHCR9Product ? (
            <TouchableOpacity onPress={() => onOpenHCR9BenefitModal(lifeNo)}>
              <Text style={sharedStyle.underlineLink}>{riderName}</Text>
            </TouchableOpacity>
          ) : <Text>{riderName}</Text>
        }
      },
      {
        title: t('CancelRider:RiskCommencementDate'),
        fieldName: 'riskCommDate',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riskCommDate = selectedRow.selectItem["riskCommDate"] as string
          return <Text>{convertStringToDateString(riskCommDate)}</Text>
        }
      },
      {
        title: t('requestInfo:RiskCessationDate'),
        fieldName: 'riskCessDate',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riskCessDate = selectedRow.selectItem["riskCessDate"] as string
          return <Text>{convertStringToDateString(riskCessDate)}</Text>
        }
      },
      {
        title: t('requestInfo:SumAssured'),
        fieldName: 'sumAssured',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const sumAssured = selectedRow.selectItem["sumAssured"] as number
          return <Text>{convertNumberToCurrencyFormat(sumAssured)}</Text>
        }
      },
      {
        title: t('CancelRider:InstallmentPremium'),
        fieldName: 'installmentPrem',
        rowRender: (selectedRow: SelectedRowProps) => {
          const installmentPrem = selectedRow.selectItem["installmentPrem"] as number
          return <Text>{convertNumberToCurrencyFormat(installmentPrem)}</Text>
        }
      },
    ]
  }

  const onOpenHCR9BenefitModal = (lifeNo: string) => {
    if (!!policyNum) {
      pipe(
        GeneralInfoService.getBenefitInformationForHCR9(policyNum),
        ZIO.fold(
          (error) => {
            setHCR9BenefitInformation([])
            setIsOpenOpenHCR9BenefitModal(true)
          },
          (response) => {
            const HCR9BenefitList = response.filter((item) => item.lifeNo === lifeNo && item.sumInsurance > 0 && item.installPremium > 0)
            setHCR9BenefitInformation(HCR9BenefitList)
            setIsOpenOpenHCR9BenefitModal(true)
          }
        ),
        ZIO.unsafeRun({})
      )
    }
  }

  const onCloseHCR9BenefitModal = () => {
    setIsOpenOpenHCR9BenefitModal(false)
  }

  const changePayoutData = (payoutInfo: PayoutPopup.Summary[]) => {
    setPayoutData([])
    if (payoutInfo && payoutInfo.length > 0) {
      setPayoutData(payoutInfo)
      const totalAmount = payoutInfo.reduce((sum, item) => {
        return item.amount + sum
      }, 0)
      const hasRequiredFileAttachment = payoutInfo.some((item) => item.method === PayoutPopup.PayoutMethods.REFUND_CARD)
      setRequireFileAttachment(hasRequiredFileAttachment)
      if (totalAmount !== netAmountAvailable) {
        showToast(t('message:MS050170'), 'error')
      }
    }
  }

  const onAllRiderSelectedEventForLA = (
    checkedAllLA: boolean,
    LAIndex: number,
    fieldItem: FieldArrayWithId<CancelRiderFormData.CancelAllRiderForm, 'LARiderForm', 'id'>
  ) => {
    if (checkedAllLA) {
      fieldItem.cancelRiderForm.forEach((subField, subIndex) => {
        const selectedElement = subField.SelectRowForRider
        if (!selectedElement && !subField.disabledRider) {
          setValue(`LARiderForm.${LAIndex}.cancelRiderForm.${subIndex}.SelectRowForRider`, true)
          setHasClickRecalRefundAmount(false)
        }
      })
    } else {
      fieldItem.cancelRiderForm.forEach((subField, subIndex) => {
        const selectedElement = subField.SelectRowForRider
        if (selectedElement && !subField.disabledRider) {
          setValue(`LARiderForm.${LAIndex}.cancelRiderForm.${subIndex}.SelectRowForRider`, false)
          setHasClickRecalRefundAmount(false)
        }
      })
    }
  }

  const onCancelAllRiderCheckedEvent = (value: boolean) => {
    cancelRiderFormArray.fields.map((fieldItem, index) => {
      setValue(`LARiderForm.${index}.selectAllForLA`, value)
      onAllRiderSelectedEventForLA(value, index, fieldItem)
    })
  }

  const convertDateStringForSubmit = (strDate: string) => {
    return moment(strDate).format('YYYY-MM-DD')
  }

  const onRecalculateRefundAmountEvent = () => {
    let riderInfoRequestList: CancelRiderFromInceptionService.RiderInfoRequest[] = []
    const formData = watch()
    formData.LARiderForm.map((lifeAssuredItem) => {
      riderInfoRequestList = [
        ...riderInfoRequestList,
        ...lifeAssuredItem.cancelRiderForm.filter((riderItem) => riderItem.SelectRowForRider).map((selectedItem) => {
          return {
            clientNumber: lifeAssuredItem.lifeAssured,
            lifeNo: selectedItem.lifeNo,
            riderNo: selectedItem.riderNo,
            coverageNo: selectedItem.coverageNo,
            coverageCode: selectedItem.riderCode,
          }
        })
      ]
    })
    const requestedBody: CancelRiderFromInceptionService.RiderRefundAmountRequest = {
      body: {
        contractNumber: policyNum,
        riderInfos: riderInfoRequestList
      }
    }
    pipe(
      CancelRiderFromInceptionService.getRiderRefundAmount(requestedBody),
      ZIO.fold(
        (error: any) => {
          showToast(error.body.oErrorResult?.errorDescription, 'error')
          setValue('riderRefundAmount', 0)
        },
        (response) => {
          setHasClickRecalRefundAmount(true)
          if (response.body.status === 'SUCCESS') {
            setValue('riderRefundAmount', response.body.total || 0)
          } else {
            const errorDescription = pipe(
              O.fromNullable(response.body.oErrorResult?.errorDescription),
              O.fold(
                () => '',
                (errorDes) => errorDes
              )
            )
            showToast(errorDescription, 'error')
            setValue('riderRefundAmount', 0)
          }
        }
      ),
      bindLoader,
      ZIO.unsafeRun({})
    )
  }

  const getUploadedFilesInfo = (formData: CancelRiderFromInceptionForm.CancelRiderFromInceptionData) => {
    let uploadedFileList: UploadedFilesInfo[] = []
    uploadedFileList.push({
      uploadFiles: formData.fileAttachment,
      transactionType: TransactionType.CANCEL_RIDER_FROM_INCEPTION,
      docTypeCode: 'DPS18',
      category: TaskType.PolicyService,
      policyNumber: policyNum,
      officeCode: officeCode || ''
    })
    uploadedFileList.push({
      uploadFiles: GeneralService.getPayoutDocuments(payoutData),
      transactionType: TransactionType.CANCEL_RIDER_FROM_INCEPTION,
      docTypeCode: 'DPS01',
      category: TaskType.PolicyService,
      policyNumber: policyNum,
      officeCode: officeCode || ''
    })
    return uploadedFileList
  }

  const getSubmissionData = (formData: CancelRiderFromInceptionForm.CancelRiderFromInceptionData) => {
    const lifeAssureds = formData.LARiderForm.map((fieldItem) => {
      const riderListForEachLA = fieldItem.cancelRiderForm
        .filter((x) => x.SelectRowForRider)
        .map((subItem) => {
          const riskCommDate = convertDateStringForSubmit(subItem.riskCommDate)
          const riskCessDate = convertDateStringForSubmit(subItem.riskCessDate)
          return {
            productCode: subItem.riderCode,
            riskCommDate: riskCommDate,
            riskCessDate: riskCessDate,
            sumAssured: subItem.sumAssured,
            installmentPremium: subItem.installmentPrem,
            lifeNo: subItem.lifeNo,
            coverageNo: subItem.coverageNo,
            riderNo: subItem.riderNo,
            status: subItem.riderStatus
          }
        })
      return {
        lifeAssured: fieldItem.lifeAssured,
        riders: riderListForEachLA
      }
    })
    const submitedData: CancelRiderFromInceptionSubmission.SubmitedData = {
      policy: {
        policyNo: policyNum
      },
      attributesExt: {
        RIDER_REFUND_AMOUNT: formData.riderRefundAmount,
        // SUSPENSE_AMOUNT: Number(formData.suspendAmount),
        REFUNDABLE_FEE_AMOUNT: 0,
        NET_AMOUNT_AVAILABLE: netAmountAvailable,
        TOTAL_PAYOUT_AMOUNT: totalPayoutAmount,
        REASON: formData.reason.value || ''
      },
      lifeAssureds: lifeAssureds.filter((x) => !!x && x.riders.length > 0),
      cashOutOptions: mapCashOutOption(payoutData)
    }
    return submitedData
  }

  const validateSubmissionRule = (formData: CancelRiderFromInceptionForm.CancelRiderFromInceptionData) => {
    if (!hasClickRecalRefundAmount) {
      showToast(t('message:MS020130'), 'error')
      return false
    } else if (formData.riderRefundAmount <= 0) {
      showToast(t('message:MS070025'), 'error')
      return false
    } else if (totalPayoutAmount <= 0) {
      showToast(t('message:MS050241'), 'error')
      return false
    } else if (totalPayoutAmount !== netAmountAvailable) {
      showToast(t('message:MS050170'), 'error')
      return false
    } else {
      return true
    }
  }

  initSubmission({
    validate: async () => {
      const isValidForm = await trigger()
      const formData = getValues()
      if (validateSubmissionRule(formData) && isValidForm) {
        return {
          url: (policyNumber: string) => `wf-api/policy/${policyNumber}/cfi-rider`,
          body: getSubmissionData(formData),
          transactionName: RequestAuthenticateData.TransactionLabelShort(TransactionType.CANCEL_RIDER_FROM_INCEPTION),
          collerationId: policyNum,
          transaction: TransactionType.CANCEL_RIDER_FROM_INCEPTION,
          method: 'POST',
          uploadedFilesInfo: getUploadedFilesInfo(formData),
        }
      } else {
        return false
      }

    },
    clear: () => {
      reset({
        LARiderForm: watch("LARiderForm"),
        cancelAllRider: false,
        fileAttachment: [],
        // suspendAmount: watch("suspendAmount"),
        reason: undefined,
        riderRefundAmount: watch("riderRefundAmount"),
        tempRefundFee: watch("tempRefundFee")
      })
      onCancelAllRiderCheckedEvent(false)
      payoutRef.current?.clearData()
    }
  })

  return (
    <SafeAreaView style={sharedStyle.container}>
      <Title title={t('CancelRiderFromInception:RIDERLIST')} wrapperStyle={sharedStyle.secondLine} />
      <Controller
        control={control}
        name="cancelAllRider"
        render={({ field: { onChange, onBlur, value } }) => (
          <Checkbox
            title={t('CancelRiderFromInception:CancelAllRider')}
            value={value}
            onChange={(val) => {
              onChange(val)
              onCancelAllRiderCheckedEvent(val)
            }}
            onBlur={onBlur}
            disabled={props.isConfirmed}
          />
        )}
      />
      {cancelRiderFormArray.fields.map((fieldItem, index) => (
        <Panel title={fieldItem.LAName} key={fieldItem.id} isNoPadding={true} isTransactionToggleExpand={true}>
          <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: 20 }}>
            <Text style={{ fontStyle: 'italic' }}>{t('requestInfo:Currency')}: VND</Text>
          </View>
          <CheckboxTable
            displayedColumns={getRiderDisplayedColumns(index, fieldItem)}
            dataSource={fieldItem.cancelRiderForm.map((item) => ({
              riderCode: item.riderCode,
              riderName: item.riderName,
              lifeNo: item.lifeNo,
              riskCommDate: item.riskCommDate,
              riskCessDate: item.riskCessDate,
              sumAssured: item.sumAssured,
              installmentPrem: item.installmentPrem,
            }))}
            containerStyle={sharedStyle.tableWrapper}
            sortItem={sortItem}
            setSortItem={setSortItem}
            isBorderedTable={false}
          />
        </Panel>
      ))}

      <SectionRow>
        <SectionCol>
          <View style={cancelRiderStyles.buttonContainer}>
            <TouchableOpacity
              disabled={isDisabledRecalRefundButton || isConfirmed}
              style={[
                sharedStyle.button,
                cancelRiderStyles.buttonContent,
                isDisabledRecalRefundButton || isConfirmed ? sharedStyle.btnDisabled : sharedStyle.btnRed
              ]}
              onPress={() => onRecalculateRefundAmountEvent()}
            >
              <Text style={[isDisabledRecalRefundButton || isConfirmed
                ? sharedStyle.btnTextDisabled
                : sharedStyle.textButtonRed]}
              >
                {t('CancelRiderFromInception:RecalculateRefundAmount')}
              </Text>
            </TouchableOpacity>
          </View>
        </SectionCol>
      </SectionRow>

      <Title title={t('CancelRiderFromInception:CANCELRIDERFROMINCEPTIONINFO')} wrapperStyle={sharedStyle.secondLine} />
      <SectionContent>
        <SectionRow>
          <SectionCol>
            <FieldText text={t('CancelRiderFromInception:RiderRefundAmount')}></FieldText>
            <FieldDescription text={formatNumberWithComma(riderRefundAmount)} isCurrencyUnit></FieldDescription>
          </SectionCol>
          {/* <SectionCol>
            <FieldText text={t('CancelRiderFromInception:SuspensePremium')}></FieldText>
            <FieldDescription text={formatNumberWithComma(watch("suspendAmount"))} isCurrencyUnit></FieldDescription>
          </SectionCol> */}
          <SectionCol>
            <FieldText text={t('Payout:TempRefundFee')}></FieldText>
            <FieldDescription text={formatNumberWithComma(watch('tempRefundFee'))} isCurrencyUnit></FieldDescription>
          </SectionCol>
        </SectionRow>
        <SectionRow sectionStyles={sharedStyle.secondLine}>
          <SectionCol>
            <FieldText text={t('CancelRiderFromInception:NetAmountAvailable')}></FieldText>
            <FieldDescription text={formatNumberWithComma(netAmountAvailable)} fieldStyles={cancelRiderStyles.red_line} isCurrencyUnit></FieldDescription>
          </SectionCol>
          <SectionCol>
            <Controller
              control={control}
              name="reason"
              rules={{
                required: {
                  value: true,
                  message: `${t('message:MS020009', { field: t('CFI:Reason') })}`
                }
              }}
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <Select
                  onBlur={onBlur}
                  onChange={onChange}
                  value={value}
                  label={t('CFI:Reason')}
                  required={true}
                  disabled={isConfirmed}
                  errorMessage={value ? '' : error?.message}
                  options={CancelFromInceptionConst.reasons}
                ></Select>
              )}
            />
          </SectionCol>
        </SectionRow>
        {hasFileNetAccess && (
          <SectionRow sectionStyles={sharedStyle.secondLine}>
            <SectionCol sectionStyles={sharedStyle.col_12}>
              <FieldText text={t('FileAttachment')} isRequired={requireFileAttachment}></FieldText>
              <Controller
                control={control}
                name={"fileAttachment"}
                rules={{
                  validate: (val) => {
                    if (requireFileAttachment && (!val || val.length <= 0)) {
                      return `${t('message:MS150004')}`
                    } else {
                      return true
                    }
                  }
                }}
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                  <>
                    <ImgUploadMutiple
                      value={value}
                      onChange={onChange}
                      timeFormat={'DD/MM/YYYY HH:mm'}
                      disabled={isConfirmed}
                    />
                    {error?.message && (
                      <Error message={value && value.length > 0 ? '' : error.message} />
                    )}
                  </>
                )}
              />
            </SectionCol>
          </SectionRow>
        )}
      </SectionContent>
      <PayoutMethod
        transactionType={TransactionType.CANCEL_RIDER_FROM_INCEPTION}
        value={payoutData}
        policyNum={props.policyNumber || ''}
        methods={allowedPayoutMethods}
        maxAmount={netAmountAvailable}
        onChange={changePayoutData}
        editable={!isConfirmed}
        isRefundCardFlag={isRefundCardFlag}
        ref={payoutRef}
        officeCode={officeCode}
        policyInfo={props.policyInfo}
      />
      <HCR9BenefitInformationModal
        isOpen={isOpenHCR9BenefitModal}
        modalTitle={t('PRUFlexiHealthBenefit:DropRiderDetailPanel')}
        HCR9BenefitInformation={HCR9BenefitInformation}
        displayedColumns={displayedBenefitColumns}
        handleClose={onCloseHCR9BenefitModal}
      />
    </SafeAreaView>
  )
}
const cancelRiderStyles = StyleSheet.create({
  btnText: {
    fontSize: 14
  },
  red_line: {
    color: '#ed1c2e',
    fontSize: 15,
    fontWeight: '700'
  },
  estimatedPremiumBtn: {
    marginTop: 15
  },
  tableHeaderText: {
    fontSize: 15,
    fontWeight: '700'
  },
  TableColText: {
    fontSize: 15
  },
  tableCheckBox: {
    padding: 0,
    marginTop: 0,
    paddingLeft: 10
  },
  buttonContent: {
    marginTop: 0,
    marginLeft: 0,
    marginBottom: 0
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
})